module.exports = __webpack_public_path__ + "img/ofgem-confidence-code.3548804d.png";